<template>
  <div class="o-hero__banner" :class="$style.footer_bar">
    <div>
      <button
        v-if="secondaryBtnText"
        :id="secondaryBtnId"
        type="button"
        :class="{
          btn: true,
          [secondaryButtonClass]: true,
          [$style.footer_button_secondary]: true,
        }"
        @click="secondaryBtnCallback"
      >
        <svg
          v-if="secondaryBtnType === 'button'"
          class="btn__icon icon icon-chevron-left"
        >
          <use
            xlink:href="../assets/images/brinkshome_icons.svg#icon-chevron-left"
          ></use>
        </svg>
        <span>{{ secondaryBtnText }}</span>
      </button>
      <button
        v-if="primaryBtnText"
        :id="primaryBtnId"
        :disabled="primaryBtnDisableState"
        type="button"
        :class="{
          btn: true,
          [primaryButtonClass]: true,
          [$style.footer_button]: true,
          [$style.btn_primary_disable]: primaryBtnDisableState,
        }"
        @click="primaryBtnCallback"
      >
        <span>{{ primaryBtnText }}</span>
        <svg
          v-if="primaryBtnType === 'button'"
          class="btn__icon btn__icon--right icon icon-chevron-right"
        >
          <use
            xlink:href="../assets/images/brinkshome_icons.svg#icon-chevron-right"
          ></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    primaryBtnText: {
      default: null,
      type: String,
    },
    primaryBtnDisableState: {
      default: false,
      type: Boolean,
    },
    primaryBtnCallback: {
      default: function() {},
      type: Function,
    },
    primaryBtnType: {
      default: 'button',
      type: String,
    },
    primaryBtnId: {
      default: null,
      type: String,
    },
    secondaryBtnText: {
      default: null,
      type: String,
    },
    secondaryBtnCallback: {
      default: function() {},
      type: Function,
    },
    secondaryBtnType: {
      default: 'button',
      type: String,
    },
    secondaryBtnId: {
      default: null,
      type: String,
    },
  },
  computed: {
    primaryButtonClass: function() {
      return this.primaryBtnType === 'button' ? 'btn-primary' : 'btn-link'
    },
    secondaryButtonClass: function() {
      return this.secondaryBtnType === 'button' ? 'btn-secondary' : 'btn-link'
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.btn_primary_disable:hover {
  color: $color-button-text;
  background-color: $color-text-primary;
}

.footer_bar {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: $height-footer;
  padding-top: 1em;
  text-align: center;
  background-color: $color-footer;
  z-index: 900;
}

.footer_button {
  width: 45%;
}

.footer_button_secondary {
  width: 45%;
  color: $color-text-secondary;
}
</style>
